"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMounting = exports.validateSidePanels = exports.validateLighting = exports.validateAwning = exports.validateConfiguration = exports.validateCustomer = void 0;
function validateCustomer(customer) {
    const errors = [];
    return { isValid: errors.length == 0, errors };
}
exports.validateCustomer = validateCustomer;
function validateConfiguration(configuration) {
    const errors = [];
    errors.push({ message: "test" });
    return { isValid: errors.length == 0, errors };
}
exports.validateConfiguration = validateConfiguration;
function validateAwning(awning) {
    const errors = [];
    return { isValid: errors.length == 0, errors };
}
exports.validateAwning = validateAwning;
function validateLighting(lighting) {
    const errors = [];
    return { isValid: errors.length == 0, errors };
}
exports.validateLighting = validateLighting;
function validateSidePanels(sidePanels) {
    const errors = [];
    return { isValid: errors.length == 0, errors };
}
exports.validateSidePanels = validateSidePanels;
function validateMounting(mounting) {
    const errors = [];
    return { isValid: errors.length == 0, errors };
}
exports.validateMounting = validateMounting;
//# sourceMappingURL=index.js.map